import React from "react";
import styled from "styled-components";
import { Subscribe } from "unstated";
//
import AppState from "state";
//
import Bars from "components/svg/fontawesome/Bars";
import Close from "components/svg/fontawesome/Close";
//
export default () => (
  <Subscribe to={[AppState]}>
    {appState => (
      <Wrap onClick={() => appState.toggleHeader()}>
        {!appState.state.headerOpen && <Bars />}
        {appState.state.headerOpen && <Close />}
      </Wrap>
    )}
  </Subscribe>
);
//
const Wrap = styled.button`
  background-color: transparent;
  border: 0;
  box-shadow: 0;
  color: inherit;
  cursor: pointer;
  display: block;
  line-height: 0;
  left: 1vw;
  outline: none;
  padding: 0.5rem;
  position: fixed;
  top: 1vw;
  width: 2rem;
  z-index: 1010;

  svg {
    display: block;
    width: 100%;
  }
`;
